<script setup lang="ts">
/*
 * Switch (on/off). Built on Headless UI's Switch primitive for keyboard +
 * screen-reader correctness; styled with brand tokens.
 */
import { Switch } from '@headlessui/vue';

withDefaults(
  defineProps<{
    modelValue: boolean;
    disabled?: boolean;
    label?: string;
  }>(),
  {},
);

defineEmits<{ 'update:modelValue': [v: boolean] }>();
</script>

<template>
  <Switch
    :model-value="modelValue"
    :disabled="disabled"
    :class="[
      'relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-pill border-2 border-transparent transition-colors focus:outline-none focus:ring-3 focus:ring-primary/20',
      modelValue ? 'bg-primary' : 'bg-slate-300',
      disabled ? 'cursor-not-allowed opacity-50' : '',
    ]"
    :aria-label="label"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <span
      :class="[
        'inline-block h-4 w-4 rounded-full bg-white shadow-sm transition-transform',
        modelValue ? 'translate-x-4' : 'translate-x-0.5',
      ]"
      aria-hidden="true"
    />
  </Switch>
</template>
